export const EMAIL_GET_ALL_SENTMAIL = "EMAIL_GET_ALL_SENTMAIL";
export const EMAIL_GET_ALL_INBOX = "EMAIL_GET_ALL_INBOX";
export const EMAIL_DELETE_INBOX = "EMAIL_DELETE_INBOX";
export const EMAIL_SEND_NEW_EMAIL = "EMAIL_SEND_NEW_EMAIL";
export const EMAIL_UPDATE_EMAIL = "EMAIL_UPDATE_EMAIL";
export const EMAIL_SAVE_AS_NEW_DRAFT = "EMAIL_SAVE_AS_NEW_DRAFT";
export const EMAIL_UPDATE_DRAFT = "EMAIL_UPDATE_DRAFT";
